const $             = require('jquery');
const { memoize }   = require('underscore');
const menu          = require('./sidenav');
const figureTpl     = require('../template/figure_tpl');

const fa = {
  image: require('@fortawesome/pro-light-svg-icons/faImage').definition,
};

class Figures {
  constructor({ container, metadata }) {
    if (!metadata.figures || !metadata.figures.length) return;
    
    this._elem = $(`<div class="figures content"></div>`);
    this._elem.appendTo(container);

    const figures = metadata.figures;
    const renderMemo = memoize(() => {
      return this._render({ figures });
    });

    menu.add({
      id: 'figures',
      icon: fa.image,
      title: 'Figures',
      badge: metadata.figures.length,
      render: renderMemo
    });
  }

  _render({ figures }) {
    this._elem.empty()
    this._elem.append(figureTpl({ figures }));
    return this._elem;
  }
}

module.exports = Figures;
